import { FC, PropsWithChildren } from 'react'
import { Box } from '@chakra-ui/react'

export const AppPageContent: FC<PropsWithChildren> = ({ children }) => (
  <Box
    w="100%"
    flex="1"
    overflowY="auto"
    px={{ base: '14px', md: '16px', lg: '22px' }}
    py={{ base: '12px', md: '14px', lg: '16px' }}
  >
    {children}
  </Box>
)
